var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersona(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33366 21.3327V26.666H10.667V29.3327H2.66699V21.3327H5.33366ZM29.3337 21.3327V29.3327H21.3337V26.666H26.667V21.3327H29.3337ZM10.0003 9.33268C10.0003 10.924 10.6325 12.4501 11.7577 13.5753C12.8829 14.7005 14.409 15.3327 16.0003 15.3327C17.5916 15.3327 19.1177 14.7005 20.243 13.5753C21.3682 12.4501 22.0003 10.924 22.0003 9.33268H24.667C24.6673 10.9185 24.2325 12.4741 23.4098 13.8299C22.5872 15.1857 21.4084 16.2898 20.0017 17.022L20.0003 25.3327H12.0003V17.0233C10.5932 16.2912 9.4139 15.187 8.59103 13.8309C7.76816 12.4748 7.33324 10.9189 7.33366 9.33268H10.0003ZM16.0003 6.66602C16.8844 6.66602 17.7322 7.01721 18.3573 7.64233C18.9825 8.26745 19.3337 9.11529 19.3337 9.99935C19.3337 10.8834 18.9825 11.7313 18.3573 12.3564C17.7322 12.9815 16.8844 13.3327 16.0003 13.3327C15.1163 13.3327 14.2684 12.9815 13.6433 12.3564C13.0182 11.7313 12.667 10.8834 12.667 9.99935C12.667 9.11529 13.0182 8.26745 13.6433 7.64233C14.2684 7.01721 15.1163 6.66602 16.0003 6.66602ZM10.667 2.66602V5.33268L5.33366 5.33135V10.666H2.66699V2.66602H10.667ZM29.3337 2.66602V10.666H26.667V5.33268H21.3337V2.66602H29.3337Z",
    fill: "#E2B900"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersona);
export default __webpack_public_path__ + "static/media/persona.f20246f9e1acef34d51538cbb95c759d.svg";
export { ForwardRef as ReactComponent };